import React, { FC } from 'react'

import { TrustIcon } from '@Components/Icons'
import { getMobileNavEvent, IconLink, TrustIconProps } from '@Components/TrustIcons/common'

export const TrustIconCH: FC<TrustIconProps> = ({ variant }: TrustIconProps) => (
  <IconLink
    event={getMobileNavEvent('vsv-versandhandel', variant)}
    href="https://www.vsv-versandhandel.ch/fr/members/detail/trendhim-aps/"
    rel="noopener noreferrer"
    target="_blank"
    variant={variant}
  >
    <TrustIcon image="frontend/trust-logos/swiss-online-guarantee-logo.png" />
  </IconLink>
)
